import React, { useEffect, useState } from "react";
import { FormattedMessage } from "react-intl";

type CountDownPropsType = {
  userRegDateTime: string;
};

function CountDown({ userRegDateTime }: CountDownPropsType) {
  const [time, setTime] = useState({ hours: 0, minutes: 0, seconds: 0 });
  const countSaleDays = Number(window.reactApp.countSaleDay) + 2;

  useEffect(() => {
    let countdown: NodeJS.Timeout;
    if (!userRegDateTime) {
      console.error("User registration date/time could not be found");
      return;
    }

    const userRegDate: Date = new Date(userRegDateTime);
    userRegDate.setDate(userRegDate.getDate() + countSaleDays);

    const updateCountdown = () => {
      const nowInLosAngeles: Date = new Date(
        new Date().toLocaleString("en-US", {
          timeZone: "America/Los_Angeles",
        }),
      );
      const nowInLosAngelesTime: number = nowInLosAngeles.getTime();
      const distance: number = userRegDate.getTime() - nowInLosAngelesTime;

      const hours: number = Math.floor(distance / (1000 * 60 * 60));
      const minutes: number = Math.floor(
        (distance % (1000 * 60 * 60)) / (1000 * 60),
      );
      const seconds: number = Math.floor((distance % (1000 * 60)) / 1000);

      setTime({ hours, minutes, seconds });

      if (distance < 0) {
        clearInterval(countdown);
        setTime({ hours: 0, minutes: 0, seconds: 0 });
      }
    };
    updateCountdown();
    countdown = setInterval(updateCountdown, 1000);

    // eslint-disable-next-line consistent-return
    return () => {
      if (countdown) {
        clearInterval(countdown);
      }
    };
  }, [countSaleDays, userRegDateTime]);

  return (
    <div className='mx-auto flex w-fit flex-wrap gap-1'>
      <div className='dark:bg-purple-dark-dark flex min-w-[74px] flex-col items-center rounded-sm bg-purple-dark p-2'>
        <span className='hours dark:text-brand-dark-secondary text-small-h font-extrabold text-brand-secondary'>
          {time.hours}
        </span>
        <span className='dark:text-purple-dark-light text-extra-small font-bold text-purple-light'>
          <FormattedMessage id='hours' />
        </span>
      </div>
      <div className='dark:bg-purple-dark-dark flex min-w-[74px] flex-col items-center rounded-sm bg-purple-dark p-2'>
        <span className='minutes dark:text-brand-dark-secondary text-small-h font-extrabold text-brand-secondary'>
          {time.minutes}
        </span>
        <span className='dark:text-purple-dark-light text-extra-small font-bold text-purple-light'>
          <FormattedMessage id='minutes' />
        </span>
      </div>
      <div className='dark:bg-purple-dark-dark flex min-w-[74px] flex-col items-center rounded-sm bg-purple-dark p-2'>
        <span className='seconds dark:text-brand-dark-secondary text-small-h font-extrabold text-brand-secondary'>
          {time.seconds}
        </span>
        <span className='dark:text-purple-dark-light text-extra-small font-bold text-purple-light'>
          <FormattedMessage id='seconds' />
        </span>
      </div>
    </div>
  );
}

export default CountDown;
